import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import JournalReportIntervarsity, {
  type JournalReportIntervarsityPoints,
} from 'donor-elf-web/lib/models/journal-report-intervarsity';
import Highcharts from 'highcharts';

interface ComponentArgs {
  reportIntervarsity: JournalReportIntervarsity;
}

export default class JournalReportIntervarsityPointsComponent extends Component<ComponentArgs> {
  chartElement: any;
  @tracked cumulativeTotal = 0;
  @tracked tooltipPoints?: JournalReportIntervarsityPoints;
  @tracked tooltipCumulativeTotal?: number;
  @tracked tooltipDate?: string;

  @action
  renderChart(e: any) {
    this.chartElement = e;
    Highcharts.chart(this.chartElement, this.chartSettings);
  }

  get pointsSeries() {
    let data: any[] = [];
    let cumulativeTotal = 0;
    for (let interval of this.args.reportIntervarsity.intervalData) {
      let formattedDate = interval.dateFormatted;
      cumulativeTotal += interval.points.total;
      let intervalCumulativeTotal = cumulativeTotal;
      data.push({
        y: interval.points.total,
        events: {
          click: () => {
            this.tooltipDate = formattedDate;
            this.tooltipPoints = interval.points;
            this.tooltipCumulativeTotal = intervalCumulativeTotal;
          },
          mouseOver: () => {
            this.tooltipDate = formattedDate;
            this.tooltipPoints = interval.points;
            this.tooltipCumulativeTotal = intervalCumulativeTotal;
          },
          mouseOut: () => {
            this.tooltipDate = undefined;
            this.tooltipPoints = undefined;
            this.tooltipCumulativeTotal = undefined;
          },
        },
      });
    }
    this.cumulativeTotal = cumulativeTotal;
    return {
      type: 'column',
      color: '#0b68a1',
      pointPadding: 0.0,
      data,
      events: {
        mouseOut: () => {
          this.tooltipDate = undefined;
          this.tooltipPoints = undefined;
          this.tooltipCumulativeTotal = undefined;
        },
      },
    };
  }

  get chartSettings() {
    let series: any[] = [this.pointsSeries];
    return {
      chart: {
        animation: false,
        height: 200,
        margin: [2, 0, 2, 0],
        borderWidth: 0,
      },
      title: {
        text: undefined,
      },
      tooltip: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        labels: {
          enabled: false,
        },
        visible: false,
        min: 0,
        max: this.args.reportIntervarsity.intervalData.length,
      },
      yAxis: {
        min: 0,
        labels: {
          enabled: false,
        },
        // max: yMax,
        title: {
          text: null,
        },
        startOnTick: false,
        endOnTick: false,
        tickPositions: [0],
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          animation: false,
          states: {
            hover: {
              enabled: true,
            },
          },
        },
      },
      series,
    } as Highcharts.Options;
  }
}
